import React, { useEffect, useState } from "react";

const AboutMe = () => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const BIRTH_DAY = new Date("1991-11-10");
    const interval = setInterval(() => {
      const now = new Date();
      const diff = Math.floor((now.getTime() - BIRTH_DAY.getTime()) / 1000);
      setSeconds(diff);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="about-me">
      <div className="about-me-container">
        <div className="about-me-text-container">
          <h2>About Me</h2>
          <p>
            Hello! I'm Daniel — an analyst and coach who’s passionate about programming and investing.
          </p>
          <p>
            Over the years, working as an analyst taught me how to think critically, work efficiently in teams, and solve complex problems — skills that now guide my journey into software development.
          </p>
          <p>
            In my free time, I enjoy learning about investing, programming, and personal growth. And yes, I like taking calculated chances!
          </p>
          <p>
            Fun fact! I've been programming for{" "}
            <span id="time-container">
              {new Intl.NumberFormat("en-US").format(seconds)}
            </span>{" "}
            seconds!
          </p>
        </div>

        <img
          src={`${process.env.PUBLIC_URL}/images/csd.png`}
          alt="Daniel Cserpak"
          className="portrait"
        />
      </div>
    </section>
  );
};

export default AboutMe;
